import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';

export const CtaBand = ({
  heading = 'Buying a car soon? Know the truth first.',
  sub = 'A CarLens Pre-Purchase Inspection puts a certified expert under the hood before you spend a dime. Inspect. Inform. Protect.',
}) => {
  const navigate = useNavigate();
  return (
    <section className="relative my-4">
      <div className="relative overflow-hidden rounded-3xl border border-orange-500/30 bg-gradient-to-br from-[#1c1c1f] via-[#242427] to-[#141416] p-8 md:p-12">
        <div className="absolute -top-24 right-0 w-80 h-80 bg-orange-500/20 blur-[120px] rounded-full pointer-events-none" />
        <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-xl">
            <div className="flex items-center gap-2 text-orange-400 text-xs font-bold uppercase tracking-[0.2em] mb-3">
              <ShieldCheck className="w-4 h-4" /> CarLens Inspections
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight" style={{ fontFamily: 'Space Grotesk' }}>
              {heading}
            </h3>
            <p className="mt-3 text-zinc-300 leading-relaxed">{sub}</p>
          </div>
          <button
            onClick={() => navigate('/book')}
            className="shrink-0 inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold px-7 py-4 rounded-full shadow-lg shadow-orange-500/25 transition-all hover:scale-[1.02]"
            data-testid="academy-book-cta"
          >
            Book an Inspection
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
